import { render } from "./addUser.vue?vue&type=template&id=7287957f&scoped=true"
import script from "./addUser.vue?vue&type=script&lang=js"
export * from "./addUser.vue?vue&type=script&lang=js"

import "./addUser.vue?vue&type=style&index=0&id=7287957f&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7287957f"]])

export default __exports__